import { useQuery } from '@tanstack/react-query'
import { fetchUnpaidInvoices } from '../subscriptions'

export const unpaidInvoicesQueryKey = (slug: string) => [slug, 'stripe', 'unpaid-invoices'] as const

const ONE_HOUR_MS = 60 * 60 * 1000

export const unpaidInvoicesQueryOptions = (slug: string) => ({
  queryKey: unpaidInvoicesQueryKey(slug),
  queryFn: () => fetchUnpaidInvoices({ slug }),
  staleTime: ONE_HOUR_MS,
  gcTime: ONE_HOUR_MS,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false
})

export const useUnpaidInvoices = (slug: string, enabled = true) =>
  useQuery({
    ...unpaidInvoicesQueryOptions(slug),
    enabled
  })
